import type { SchemaListItem } from '@morph-mapper/types';
import api from '../api';
import type { SchemaListFilters } from './types';
import { toListSchemasParams } from './utils';

export const listSchemas = async (
  filters: SchemaListFilters = {},
): Promise<SchemaListItem[]> => {
  const { data } = await api.get<SchemaListItem[]>('/schemas', {
    params: toListSchemasParams(filters),
  });

  return data;
};

export const fetchSchemaById = async (id: string): Promise<SchemaListItem> => {
  const { data } = await api.get<SchemaListItem>(`/schemas/${id}`);

  return data;
};
